import React from 'react';
import { bool, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import SafePureComponent from '../shared/SafePureComponent';
import { shouldRenderCustomOrder } from '../../utils/customOrder';
import isInCustomOrderPackageTest from '../../utils/experiments/customOrderPackage';
import { isSinglePackage } from '../../reducers/packages';
import CustomOrder from './CustomOrder';
import ContactSellerBtn from './ContactSellerBtn';

import './style.scss';

const ContactSeller = ({ customOrder, isSinglePackage }, { general, requestContext }) => {
    const { ab_tests: abTests, current_user: currentUser } = requestContext;
    const { isOnVacation } = general;
    const inCustomOrderPackageTest = isInCustomOrderPackageTest(abTests);

    const customOrderEligible = shouldRenderCustomOrder({
        customOrder,
        general,
        currentUser,
        inCustomOrderPackageTest
    });

    const shouldDisplayCustomOrder = customOrderEligible;
    const shouldDisplayContactSeller = !isOnVacation && !customOrderEligible;

    const wrapperClass = classNames('contact-seller', {
        'display-custom-order': shouldDisplayCustomOrder,
        'display-contact-seller': shouldDisplayContactSeller,
        'in-custom-order-package-test': inCustomOrderPackageTest,
        'single-package': isSinglePackage
    });

    return (
        <div className={wrapperClass}>
            <CustomOrder/>
            <ContactSellerBtn/>
        </div>
    );
};

ContactSeller.propTypes = {
    customOrder: shape({
        currentUserStatus: string,
        allowCustomOrders: bool
    })
};

ContactSeller.defaultProps = {
    customOrder: {
        allowCustomOrders: true
    }
};

ContactSeller.contextTypes = {
    requestContext: object,
    general: object
};

const mapStateToProps = ({ packages }) => ({
    isSinglePackage: isSinglePackage(packages)
});

export { ContactSeller };
export default SafePureComponent(connect(mapStateToProps)(ContactSeller));
